export enum LayoutType {
	general = 'general',
	registrationDocument = 'registrationDocument'
}
